/**
 * 聚焦 CAD 命令提示输入框，优先避免页面滚动。
 *
 * @param inputElement - 目标输入元素
 * @param shouldSelect - 是否同时选中已有文本，默认 false
 */
export function focusCadTipInput(inputElement: HTMLInputElement, shouldSelect = false) {
  try {
    inputElement.focus({ preventScroll: true })
  } catch {
    inputElement.focus()
  }
  if (shouldSelect) {
    inputElement.select()
  }
}
